module.exports = __webpack_public_path__ + "static/media/level_11-12.121c1705.jpg";